var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgResponsible = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 22,
  fill: "none",
  viewBox: "0 0 18 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M9 0 0 4v6c0 5.555 3.835 10.735 9 12 5.165-1.265 9-6.445 9-12V4zm0 19.925V11H2V5.3l7-3.11v8.8h7c-.53 4.12-3.275 7.79-7 8.935"
})));
export default SvgResponsible;